```vue
<template>
  <div class="centreSection">
    <b-container>

      <!-- CENTRE SECTION -->
      <template v-if="sec === 'centre'">
        <b-row class="align-items-center">

          <!-- IMAGE -->
          <b-col
            lg="6"
            md="12"
            class="imageCol"
          >
            <div class="imageWrap">

              <div class="imageAccent"></div>

              <b-img
                :class="{ disk: id === 158 }"
                :src="acf.acf.image_3"
                fluid
                class="featureImage"
              ></b-img>

            </div>
          </b-col>

          <!-- CONTENT -->
          <b-col
            lg="6"
            md="12"
            class="contentCol"
          >
            <div class="textSec">

              <div class="featureContent">

                <span class="eyebrow">
                  OCS Sport
                </span>

                <h3 class="featureTitle">
                  {{ acf.acf.title_3 }}
                </h3>

                <div class="titleLine"></div>

                <div
                  class="featureText"
                  v-html="acf.acf.text_3"
                ></div>

                <h4
                  v-if="acf.acf.title_3_1"
                  class="featureSubtitle"
                >
                  {{ acf.acf.title_3_1 }}
                </h4>

                <div class="featureList">

                  <div
                    v-if="acf.acf.apps_bullet"
                    class="featureItem"
                  >
                    <span class="featureLine"></span>
                    <span>{{ acf.acf.apps_bullet }}</span>
                  </div>

                  <div
                    v-if="acf.acf.apps_bullet_1"
                    class="featureItem"
                  >
                    <span class="featureLine"></span>
                    <span>{{ acf.acf.apps_bullet_1 }}</span>
                  </div>

                  <div
                    v-if="acf.acf.apps_bullet_2"
                    class="featureItem"
                  >
                    <span class="featureLine"></span>
                    <span>{{ acf.acf.apps_bullet_2 }}</span>
                  </div>

                  <div
                    v-if="acf.acf.apps_bullet_3"
                    class="featureItem"
                  >
                    <span class="featureLine"></span>
                    <span>{{ acf.acf.apps_bullet_3 }}</span>
                  </div>

                  <div
                    v-if="acf.acf.apps_bullet_4"
                    class="featureItem"
                  >
                    <span class="featureLine"></span>
                    <span>{{ acf.acf.apps_bullet_4 }}</span>
                  </div>

                  <div
                    v-if="acf.acf.apps_bullet_5"
                    class="featureItem"
                  >
                    <span class="featureLine"></span>
                    <span>{{ acf.acf.apps_bullet_5 }}</span>
                  </div>

                  <div
                    v-if="acf.acf.apps_bullet_6"
                    class="featureItem"
                  >
                    <span class="featureLine"></span>
                    <span>{{ acf.acf.apps_bullet_6 }}</span>
                  </div>

                </div>

              </div>

            </div>
          </b-col>

        </b-row>
      </template>

    </b-container>
  </div>
</template>

<script>
export default {
  name: "leftImg",

  props: ["acf", "id", "sec"],
};
</script>

<style scoped>

/* ========================================
   SECTION
======================================== */

.centreSection {
  position: relative;
  padding: 100px 0;
}

::v-deep .container {
  max-width: 1400px;
  padding: 0 25px;
}


/* ========================================
   IMAGE
======================================== */

.imageCol {
  position: relative;
  padding: 30px 50px 30px 15px;
}

.imageWrap {
  position: relative;
}

.featureImage {
  position: relative;
  z-index: 2;
  width: 100%;
  display: block;
  border-radius: 4px;
}


/* Decorative shape */

.imageWrap::before {
  content: "";
  position: absolute;
  top: -25px;
  left: -25px;
  width: 110px;
  height: 110px;
  background: #00aeef;
  opacity: 0.08;
  z-index: 1;
}

.imageAccent {
  position: absolute;
  right: -10px;
  bottom: -20px;
  width: 140px;
  height: 140px;
  border: 2px solid #00aeef;
  opacity: 0.2;
  z-index: 1;
}


/* ========================================
   CONTENT
======================================== */

.contentCol {
  padding: 30px 15px 30px 50px;
}

.featureContent {
  max-width: 620px;
}


/* ========================================
   EYEBROW
======================================== */

.eyebrow {
  display: inline-block;
  margin-bottom: 14px;
  color: #00aeef;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
}


/* ========================================
   TITLE
======================================== */

.featureTitle {
  margin: 0;
  color: #003460;
  font-size: 42px;
  font-weight: 400;
  line-height: 1.15;
  letter-spacing: -0.5px;
}

.titleLine {
  width: 55px;
  height: 3px;
  margin: 22px 0 25px;
  background: #00aeef;
}


/* ========================================
   BODY TEXT
======================================== */

.featureText {
  color: #59636d;
  font-size: 17px;
  line-height: 1.75;
  margin-bottom: 35px;
}

.featureText p {
  margin-bottom: 15px;
}


/* ========================================
   SUBTITLE
======================================== */

.featureSubtitle {
  position: relative;
  margin: 0 0 20px;
  padding-left: 18px;
  color: #003460;
  font-size: 21px;
  font-weight: 500;
  line-height: 1.4;
}

.featureSubtitle::before {
  content: "";
  position: absolute;
  left: 0;
  top: 2px;
  width: 4px;
  height: calc(100% - 4px);
  background: #00aeef;
}


/* ========================================
   FEATURES
======================================== */

.featureList {
  display: flex;
  flex-direction: column;
}

.featureItem {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 13px 0;
  border-bottom: 1px solid rgba(0, 52, 96, 0.12);
  color: #59636d;
  font-size: 16px;
  line-height: 1.55;
}

.featureItem:first-child {
  padding-top: 0;
}

.featureItem:last-child {
  border-bottom: none;
}


/* Small blue accent */

.featureLine {
  flex: 0 0 auto;
  width: 24px;
  height: 2px;
  margin-top: 10px;
  background: #00aeef;
}


/* ========================================
   DISK
======================================== */

.disk {
  margin-top: -100px;
  margin-bottom: -100px;
}


/* ========================================
   TABLET
======================================== */

@media only screen and (max-width: 1240px) {

  .centreSection {
    padding: 80px 0;
  }

  .imageCol {
    padding-right: 30px;
  }

  .contentCol {
    padding-left: 30px;
  }

  .featureTitle {
    font-size: 36px;
  }

  .disk {
    margin-top: 0;
    margin-bottom: 0;
  }
}


/* ========================================
   MOBILE
======================================== */

@media only screen and (max-width: 991px) {

  .centreSection {
    padding: 70px 0;
  }

  .imageCol {
    padding: 20px 15px 50px;
  }

  .contentCol {
    padding: 20px 15px;
  }

  .featureContent {
    max-width: none;
  }

  .featureTitle {
    font-size: 34px;
  }

  .imageAccent {
    right: 0;
  }
}


/* ========================================
   SMALL MOBILE
======================================== */

@media only screen and (max-width: 767px) {

  .centreSection {
    padding: 50px 0;
  }

  ::v-deep .container {
    padding: 0 20px;
  }

  .imageCol {
    padding: 10px 10px 45px;
  }

  .contentCol {
    padding: 10px;
  }

  .featureTitle {
    font-size: 30px;
  }

  .featureText {
    font-size: 16px;
    line-height: 1.7;
  }

  .featureSubtitle {
    font-size: 19px;
  }

  .featureItem {
    font-size: 15px;
    gap: 12px;
  }

  .imageWrap::before {
    top: -15px;
    left: -15px;
    width: 70px;
    height: 70px;
  }

  .imageAccent {
    right: -5px;
    bottom: -15px;
    width: 90px;
    height: 90px;
  }
}


/* ========================================
   VERY SMALL MOBILE
======================================== */

@media only screen and (max-width: 480px) {

  .centreSection {
    padding: 40px 0;
  }

  .featureTitle {
    font-size: 27px;
  }

  .eyebrow {
    font-size: 11px;
    letter-spacing: 1.5px;
  }

  .titleLine {
    margin: 18px 0 20px;
  }

  .featureLine {
    width: 18px;
  }
}

</style>
